<!-- 查看提现申请 -->
<template>
  <div>
    <app-breadcrumb />
    <div class="page-container view-apply">
      <el-form v-loading="formLoading" :model="viewObj" label-width="110px">
        <h3 style="color: #b3640d">{{ $t('Common.basicInfomation') }}</h3>
        <!-- 申请单号 -->
        <el-form-item :label="$t('miMemberApalyCheck.askForNo') + ':'">{{ viewObj.applNo }}</el-form-item>
        <!-- 账户类型 -->
        <el-form-item :label="$t('title.accout.type') + ':'">{{ $lt(initDict.acType, viewObj.acType) }}</el-form-item>
        <!-- 申请金额 -->
        <el-form-item :label="$t('member.sqje') + ':'">{{ viewObj.amount }}</el-form-item>
        <!-- 税费 -->
        <el-form-item :label="$t('bd.tax') + ':'">{{ viewObj.fees }}</el-form-item>
        <!-- 实发金额 -->
        <el-form-item :label="$t('fiBonusAppl.sendAmt') + ':'">{{ viewObj.sendAmt }}</el-form-item>
        <!-- 发放金额 -->
        <el-form-item :label="$t('FiAcAppl.localMoney') + ':'">{{ viewObj.localMoney }}</el-form-item>
        <!-- 申请时间 -->
        <el-form-item :label="$t('miMemberApply.createTime') + ':'">{{ viewObj.createTime }}</el-form-item>
        <!-- 申请状态 -->
        <el-form-item :label="$t('csServiceCenter.status') + ':'">{{ $lt(initDict.status, viewObj.status)
        }}</el-form-item>
        <!-- 失败原因 -->
        <el-form-item v-if="viewObj.status === 4 || viewObj.status === 6"
          :label="$t('pmProductSppm.checkDate') + ':'">{{
            viewObj.falseReason }}</el-form-item>
        <!-- 审核时间 -->
        <el-form-item :label="$t('pmProductSppm.checkDate') + ':'">{{ viewObj.checkTime }}</el-form-item>
        <!-- 摘要 -->
        <el-form-item :label="$t('sys.notes') + ':'">{{ viewObj.remark }}</el-form-item>
        <div style="text-align: center; margin-bottom: 10px">
          <el-button icon="el-icon-close" @click="$router.back(-1)">{{ $t('operation.button.cancel') }}</el-button>
        </div>
      </el-form>
    </div>
  </div>
</template>

<script>
import { viewFiAcAppl } from '@/api/ay-account-manager'

export default {
  name: "ViewApply",
  data() {
    return {
      formLoading: false,
      viewObj: {},
      initDict: {
        acType: 'fiacinput.actype.cn',
        status: 'fi_ac_appl_status_cn'
      }
    }
  },
  created() {
    this.formLoading = true
    viewFiAcAppl({ 'id': this.$route.params.id }).then(res => {
      this.viewObj = res.data
      this.formLoading = false
    }).catch(() => {
      this.$message.error(this.$t('bdSendRegister.operaterFail'))
      this.$router.go(-1)
    })
  }
}
</script>

<style scoped lang="scss">
.view-apply {
  div {
    margin: 0;
  }
}
</style>